module.exports = "https://cdn.thelire.com/ins/resource/question.f7dce84df7bbffaedf8710d692efa4c6.png";